import React from 'react';
import moment from 'moment';

const StatusBadgeClass = {
    DRAFT: 'badge-secondary',
    READY: 'badge-info',
    SCHEDULED: 'badge-primary',
    QUEUED: 'badge-warning',
    SENDING: 'badge-primary',
    COMPLETED: 'badge-success',
    FAILED: 'badge-danger',
}

const CampaignListTable = (props) => {
    const {campaigns} = props

    return (
        <>
            <table
                className='table table-bordered table-hover dataTable dtr-inline text-nowrap text-center'
            >
                <thead>
                <tr>
                    <th>No.</th>
                    <th>ID</th>
                    <th>Tên Campaign</th>
                    <th>Trạng thái</th>
                    <th>Số người nhận</th>
                    <th>Đã gửi</th>
                    <th>Lịch gửi</th>
                    <th>Ngày tạo</th>
                </tr>
                </thead>
                <tbody>
                {campaigns && campaigns.length > 0 && campaigns.map((campaign, index) => (
                    <tr key={`campaign_${campaign.id}`}>
                        <td>{campaign.no ? campaign.no : index + 1}</td>
                        <td className={"text-truncate"}>{campaign.id}</td>
                        <td className={"text-truncate"}>
                            <a href={`/mail/campaign/detail/${campaign.id}`}>{campaign.name}</a>
                        </td>
                        <td className={"text-truncate"}>
                            <span className={`badge badge-pill ${StatusBadgeClass[campaign.status] || 'badge-secondary'}`}>
                                {campaign.status}
                            </span>
                        </td>
                        <td className={"text-truncate"}>{campaign.total_recipients}</td>
                        <td className={"text-truncate"}>{campaign.sent_count}</td>
                        <td className={"text-truncate"}>
                            {campaign.scheduled_send_time ? moment(campaign.scheduled_send_time).format('YYYY-MM-DD HH:mm') : '-'}
                        </td>
                        <td className={"text-truncate"}>
                            {campaign.created_at ? moment(campaign.created_at).format('YYYY-MM-DD HH:mm') : ''}
                        </td>
                    </tr>
                ))}
                </tbody>
            </table>
        </>
    );
};

export default CampaignListTable;
